// |-- Built-in Dependencies --|
import React, { useState, useEffect } from "react";

// |-- External Dependencies --|
import { useDispatch, useSelector } from "react-redux";

// |-- Internal Dependencies --|
import DispositionLevelTwoListing from "./DispositionLevelTwoListing";
import AddDispositionLevelTwoFormWrapper from "../Add/AddDispositionLevelTwoFormWrapper";

// |-- Redux --|
import { AppDispatch, RootState } from "src/redux/store";
import { setItems } from "src/redux/slices/DispositionLevelTwoSlice";
import { useGetAllDispositionLevelTwoByLevelOneIdQuery } from "src/services/DispositionLevelTwoServices";
import { DispositionLevelTwoListResponse } from "src/models/DispositionLevelTwo.model";

const DispositionLevelTwoListingWrapper = () => {
  const [isOpenAddForm, setIsOpenAddForm] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const { items, filterValue }: any = useSelector(
    (state: RootState) => state.dispositionLevelTwo
  );

  const dispositionLevelsTwo = items?.map(
    (ele: DispositionLevelTwoListResponse) => {
      return { label: ele.dispositionSecondName, value: ele._id };
    }
  );

  // Get All Disposition level two values accroding to one
  const { data, isLoading, isFetching } =
    useGetAllDispositionLevelTwoByLevelOneIdQuery(filterValue, {
      skip: !filterValue,
    });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      dispatch(setItems(data?.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  return (
    <>
      <DispositionLevelTwoListing
        states={dispositionLevelsTwo}
        onAddNew={() => setIsOpenAddForm(true)}
      />
      {isOpenAddForm && (
        <AddDispositionLevelTwoFormWrapper
          onClose={() => setIsOpenAddForm(false)}
        />
      )}
    </>
  );
};

export default DispositionLevelTwoListingWrapper;
